import { createFileRoute, notFound } from '@tanstack/react-router';

import { SeasonWorkspacePage } from '@/components/admin/sport/season-workspace-page';
import { adminHead } from '@/lib/seo';
import { adminSeasonWorkspaceFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/editions_/$id')({
    component: EditionRoute,
    head: ({ params, loaderData }) =>
        adminHead(
            loaderData?.competition?.name ?? 'טורניר',
            `/admin/sport/editions/${encodeURIComponent(params.id)}`,
        ),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: async ({ params }) => {
        const data = await adminSeasonWorkspaceFn({ data: { id: params.id } });
        if (!data) throw notFound();
        return data;
    },
});

function EditionRoute() {
    const data = Route.useLoaderData();
    return <SeasonWorkspacePage key={`${data.edition.id}:${String(data.season.updatedAt)}`} initial={data} />;
}
